import { api } from '@/lib/api'

import type {
  NotificationListResponse,
  NotificationPreferencesResponse,
} from './types'

function base(slug: string): string {
  return `/api/v2/orgs/${encodeURIComponent(slug)}`
}

export const notificationsApi = {
  list: (slug: string, query: { unread?: boolean; before?: number; limit?: number } = {}) =>
    api.get<NotificationListResponse>(`${base(slug)}/notifications`, {
      query: {
        unread: query.unread ? 1 : undefined,
        before: query.before,
        limit: query.limit,
      },
    }),

  unreadCount: (slug: string) =>
    api.get<{ unread: number }>(`${base(slug)}/notifications/unread-count`),

  markRead: (slug: string, id: number) =>
    api.post<{ unread: number }>(`${base(slug)}/notifications/${id}/read`),

  markUnread: (slug: string, id: number) =>
    api.post<{ unread: number }>(`${base(slug)}/notifications/${id}/unread`),

  markAllRead: (slug: string) =>
    api.post<{ unread: number }>(`${base(slug)}/notifications/read-all`),

  preferences: (slug: string) =>
    api.get<NotificationPreferencesResponse>(`${base(slug)}/notification-preferences`),

  updatePreferences: (
    slug: string,
    input: {
      email_enabled?: boolean
      preferences: Array<{ type: string; in_app: boolean; email: boolean }>
    },
  ) => api.put<NotificationPreferencesResponse>(`${base(slug)}/notification-preferences`, input),
}
